import styled from "styled-components";
import { motion } from "motion/react";

export const ItemsFolderContainer = styled(motion.a)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  height: fit-content;
  cursor: pointer;
  width: 70px;

  text-decoration: none;
  color: ${(props) => props.theme.black};
`;

export const ItemsFolderIcon = styled.img`
  width: 40px;
  height: 40px;
`;

export const ItemsFolderName = styled.div`
  font-size: ${(props) => props.theme.fontNormal}px;
  width: 80%;
  text-align: center;
`;
